// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ERRj","clinicsSelect":"styles_clinicsSelect__33G3h"};